import * as React from 'react';
import {Card, InlineStack, Spinner, Box} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';

import styles from './LoadingBar.scss';

export interface LoadingBarProps {
  /** determines whether LoadingBar is visible */
  loading: boolean;
  /**  custom loading text */
  text?: React.ReactNode;
}

export const LoadingBar = ({loading, text}: LoadingBarProps) => {
  const [i18n] = useI18n();

  if (!loading) {
    return null;
  }

  return (
    <Card roundedAbove="sm">
      <InlineStack gap="200" blockAlign="start" wrap={false}>
        <div className={styles.Spinner}>
          <Spinner size="small" />
        </div>
        <Box>{text || i18n.translate('loadingDefault')}</Box>
      </InlineStack>
    </Card>
  );
};
